import { t } from "../../../../i18n";
import { useTheme } from '@mui/material/styles';
import { Grid2 as Grid, Stack, Typography, useMediaQuery } from '@mui/material';
import AuthForgetPasswordSubmit from '../auth-forms/AuthForgetPasswordSubmit';

// ================================|| AUTH3 - LOGIN ||================================ //

function ForgetPasswordSubmit() {
  const theme = useTheme();
  const matchDownSM = useMediaQuery(theme.breakpoints.down('md'));
  return <Grid container spacing={2} alignItems="center" justifyContent="center">
            <Grid size={12}>
                <Grid container direction={matchDownSM ? 'column-reverse' : 'row'} alignItems="center" justifyContent="center">
                    <Grid>
                        <Stack alignItems="center" justifyContent="center" spacing={1}>
                            <Typography color={theme.palette.secondary.main} gutterBottom variant={matchDownSM ? 'h3' : 'h2'}>{t("Alterar palavra-passe")}</Typography>
                            <Typography variant="caption" fontSize="16px" textAlign={matchDownSM ? 'center' : 'inherit'}>{t("Introduza o seu código, recebido no email, e defina uma nova palavra-passe.")}</Typography>
                        </Stack>
                    </Grid>
                </Grid>
            </Grid>
            <Grid size={12}>
                <AuthForgetPasswordSubmit />
            </Grid>
        </Grid>;
}
export default ForgetPasswordSubmit;
